"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefinitionList = function (_React$Component) {
    _inherits(DefinitionList, _React$Component);

    function DefinitionList() {
        _classCallCheck(this, DefinitionList);

        return _possibleConstructorReturn(this, (DefinitionList.__proto__ || Object.getPrototypeOf(DefinitionList)).apply(this, arguments));
    }

    _createClass(DefinitionList, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                items = _props.items,
                headers = _props.headers;


            return _react2.default.createElement(
                "div",
                null,
                items.map(function (item, itemIndex) {
                    return _react2.default.createElement(
                        "dl",
                        { key: itemIndex },
                        item.map(function (property, propertyIndex) {
                            return [_react2.default.createElement(
                                "dt",
                                { key: "term_" + propertyIndex },
                                headers[propertyIndex]
                            ), _react2.default.createElement(
                                "dd",
                                { key: "definition_" + propertyIndex },
                                property
                            )];
                        })
                    );
                })
            );
        }
    }]);

    return DefinitionList;
}(_react2.default.Component);

DefinitionList.displayName = "DefinitionList";

DefinitionList.propTypes = {
    item: _propTypes2.default.array,
    headers: _propTypes2.default.array
};

exports.default = DefinitionList;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/TableList/DefinitionList.js
// module id = 988
// module chunks = 95715928098905 168707334958949